export default {
  CLEAR_CURRENT: 'TRANSACTIONS_CLEAR_CURRENT',
  GET_REQUEST: 'TRANSACTIONS_GET_REQUEST',
  GET_SUCCESS: 'TRANSACTIONS_GET_SUCCESS',
  GET_FAILURE: 'TRANSACTIONS_GET_FAILURE',

  SAVE_REQUEST: 'TRANSACTIONS_SAVE_REQUEST',
  SAVE_SUCCESS: 'TRANSACTIONS_SAVE_SUCCESS',
  SAVE_FAILURE: 'TRANSACTIONS_SAVE_FAILURE',

  GETALL_REQUEST: 'TRANSACTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'TRANSACTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'TRANSACTIONS_GETALL_FAILURE',

  DELETE_REQUEST: 'TRANSACTIONS_DELETE_REQUEST',
  DELETE_SUCCESS: 'TRANSACTIONS_DELETE_SUCCESS',
  DELETE_FAILURE: 'TRANSACTIONS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'TRANSACTIONS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'TRANSACTIONS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'TRANSACTIONS_UPDATE_FAILURE'    

};